// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLReinstatePolicyPage__disabled-as-readonly{cursor:unset!important;opacity:unset!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-reinstatement-react/pages/MLReinstatePolicy/MLReinstatePolicyPage.module.scss"],"names":[],"mappings":"AAAA,kDAEI,sBAAA,CADA,uBACA","sourcesContent":[".disabled-as-readonly{\n    opacity: unset !important;\n    cursor: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled-as-readonly": "app__MLReinstatePolicyPage__disabled-as-readonly"
};
export default ___CSS_LOADER_EXPORT___;
